import { useState } from 'react';

import { SubNav } from '../members/MembersSection';
import { OrdersView } from './OrdersView';
import { ProductsView } from './ProductsView';
import { ReportsView } from './ReportsView';
import { SaleView } from './SaleView';

type Tab = 'encomendas' | 'venda' | 'produtos' | 'relatorios';

const TABS: { id: Tab; label: string }[] = [
  { id: 'encomendas', label: 'Encomendas' },
  { id: 'venda', label: 'Venda ao balcão' },
  { id: 'produtos', label: 'Produtos' },
  { id: 'relatorios', label: 'Relatórios' },
];

/** Loja: everything needs `store.manage` (Store Manager, General Admin). */
export function StoreSection() {
  const [tab, setTab] = useState<Tab>('encomendas');
  const [orderId, setOrderId] = useState<string | null>(null);

  return (
    <>
      <SubNav tabs={TABS} current={tab} onChange={setTab} label="Loja" />
      {tab === 'encomendas' ? <OrdersView selectedId={orderId} onSelect={setOrderId} /> : null}
      {tab === 'venda' ? (
        <SaleView
          onSold={(id) => {
            setOrderId(id);
            setTab('encomendas');
          }}
        />
      ) : null}
      {tab === 'produtos' ? <ProductsView /> : null}
      {tab === 'relatorios' ? <ReportsView /> : null}
    </>
  );
}
